"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.8 25",
    width: "20.8",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,25H0.5C0.2,25,0,24.8,0,24.5v-24C0,0.2,0.2,0,0.5,0h13.6c0.1,0,0.3,0.1,0.4,0.1l6.3,6.3c0.1,0.1,0.1,0.2,0.1,0.4 v17.7C20.8,24.8,20.6,25,20.3,25z M1,24h18.8V7l-6-6H1V24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,7.3h-6.3c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5.8h5.8c0.3,0,0.5,0.2,0.5,0.5 S20.6,7.3,20.3,7.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,20H9.9c-0.3,0-0.5-0.2-0.5-0.5v-5.4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V19h2.1c0.3,0,0.5,0.2,0.5,0.5 S12.8,20,12.5,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7,20c-0.2,0-0.4-0.1-0.5-0.3L4,14.3c-0.1-0.2,0-0.5,0.2-0.7c0.2-0.1,0.5,0,0.7,0.2l2.6,5.4c0.1,0.2,0,0.5-0.2,0.7 C7.2,20,7.1,20,7,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.4,20c-0.1,0-0.1,0-0.2,0C4,19.8,3.8,19.5,4,19.3l2.6-5.4c0.1-0.2,0.4-0.4,0.7-0.2c0.2,0.1,0.4,0.4,0.2,0.7l-2.6,5.4 C4.8,19.9,4.6,20,4.4,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.8,20.1c-0.9,0-1.7-0.8-1.8-1.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.5,0.4,0.8,0.8,0.8 c0.4,0,0.8-0.4,0.8-0.9c0-0.5-0.2-0.7-0.9-0.9c0,0-0.1,0-0.1,0c-1.3-0.3-1.6-1.2-1.6-1.8c0-1,0.8-1.9,1.8-1.9 c0.9,0,1.7,0.8,1.8,1.8c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.5-0.4-0.8-0.8-0.8c-0.4,0-0.8,0.4-0.8,0.9 c0,0.6,0.4,0.8,0.9,0.9l0,0.5l0.1-0.5c1.3,0.3,1.6,1.2,1.6,1.9C17.6,19.3,16.8,20.1,15.8,20.1z"
  }));
};

exports["default"] = _default;